import React from "react";
import { Link } from "react-router-dom";

const Header = () => (
  <header className="header">
    <Link to="/">Pokatchér</Link>
  </header>
);

export default Header;
